module.exports = __webpack_public_path__ + "img/194.53d599f5.jpg";